import { EnvConfigContext } from './context';

export const EnvConfigProvider = EnvConfigContext.Provider;
